import React, {Component, useEffect, useState} from "react";
import 'swiper/swiper-bundle.css';
import "./Report.scss";
import SimpleLineIcon from "react-simple-line-icons";
import {Nav} from "../../Components";
import {ConvertToJalali, FactorData} from "../StoreDetail/StoreDetailServices";
import Rodal from "rodal";
import {ReportData} from "./ReportServices";
import Skeleton from "react-loading-skeleton";


function InvCard_skeleton({show}) {

    return (
        <>
            {show ? <div className="report-card">
                <div className="price">
                    <span><Skeleton width={50}/></span>
                </div>
                <div className="info">
                    <span><Skeleton width={100}/></span>
                    <Skeleton width={60} height={60} circle={true}/>
                </div>
            </div> : null}
        </>
    )
}


function InvCard({getFactorDetail, item}) {

    const [load, setLoad] = useState(false);

    const numberWithCommas = (x) => {
        if (x === 0) {
            return 0
        }
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    const convertState = (state) =>{
        switch (state) {
            case 'waiting_to_pay':
                return "منتظر پرداخت"
                break;
            case 'invalidated':
                return "نامعتبر"
                break;
            case 'success_to_pay':
                return "پرداخت شده"
                break;
        }
    }

    const convertStateStyle = (state) =>{
        switch (state) {
            case 'waiting_to_pay':
                return "wait_pay"
                break;
            case 'invalidated':
                return "invalid_pay"
                break;
            case 'success_to_pay':
                return "success_pay"
                break;
        }
    }



    return (
        <div className="report-card" onClick={async () => {
            setLoad(true);
            let status = await getFactorDetail(item.uid);
            setLoad(false)

        }}>
            <div className="price">
                <SimpleLineIcon name="arrow-left"/>
                <span>ریال</span>
                <span>{numberWithCommas(item.payable_amount)}</span>
            </div>
            <div className="info">
                <div className="report-card-info-wr">
                    <span>{item.merchant.name}</span>
                    <span className={convertStateStyle(item.state)}>{convertState(item.state)}</span>
                </div>
                {load ? <i className="fa fa-spinner fa-spin" style={{fontSize: 28}}></i> :
                    <img src={item.merchant.thumbnail} alt="" style={{width: 40, height: 40, borderColor: '#e56767'}}/>
                }
            </div>
        </div>
    )
}


function Report() {


    const [selectedReport, setSelectedReport] = useState("cat");
    const [showModal, setShowModal] = useState(false);
    const [factor, setFactor] = useState({});


    const numberWithCommas = (x) => {
        if (x === 0) {
            return 0
        }
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }



    const [invo, setInvo] = useState([])
    const [load, setLoad] = useState(true)

    const getReport = async () => {
        try {
            const reportData = await ReportData();
            setLoad(false)
            // console.log("re", reportData)
            setInvo(reportData.data.results)
        } catch (e) {
            setLoad(false)
            // console.log(e)
        }
    }

    const getReportPage = async () => {
        try {
            const reportData = await ReportData(window.currentPage);
            setLoad(false)
            // console.log("re", reportData)
            setInvo((list)=>[...list,...reportData.data.results]);
        } catch (e) {
            setLoad(false)
            // console.log(e)
        }
    }


    const HandleScrollListener = async () =>{
        const doc = document.documentElement;
        let calc = doc.scrollHeight -(doc.scrollTop + doc.clientHeight)
        let cond = calc>3 || calc<-3

        if(!cond) {
            console.log("bottonnnnn current");
            window.currentPage = window.currentPage +1
            getReportPage()
        }
    }

    useEffect(()=>{
        //handle scroll arrived to Top
        window.currentPage = 1;
        window.addEventListener('scroll',HandleScrollListener);
        return () => {
            window.removeEventListener('scroll', HandleScrollListener); // Remove Scroll Event Listener
        };
    },[])

    const getFactorDetail = async (id) => {
        try {
            const factor = await FactorData(id);
            setFactor(factor.data);
            setShowModal(true)
            return true;
        } catch (e) {
            // console.log(e)
            return false;
        }
    }


    useEffect(() => {
        window.scrollTo(0, 0);
        getReport().then()
    }, [])


    return (
        <div className="report-container">

            <Rodal animation={"zoom"} visible={showModal} onClose={() => setShowModal(false)}>

                <div className="factor-header">
                    <div className="factor-header-item left">
                        <span className="factor-header-item-title">تاریخ</span>
                        {factor.created ?
                            <span className="factor-header-item-val">{ConvertToJalali(factor.created)}</span> : null}
                    </div>
                    <div className="factor-header-item right">
                        <span className="factor-header-item-title">شماره فاکتور</span>
                        {factor.uid ? <span className="factor-header-item-val">{factor.uid}</span> : null}
                    </div>
                </div>

                <div className="factor-table">
                    <table>
                        <thead>
                        <tr>
                            <th className="product-table-head">جمع کل</th>
                            {/*<th className="product-table-head">تخفیف</th>*/}
                            <th className="product-table-head">تعداد</th>
                            <th className="product-table-head product-table-head-name">نام کالا</th>
                            <th className="product-table-head product-table-head-name">تصویر</th>
                        </tr>
                        </thead>
                        <tbody>
                        {factor.products && factor.products.map(product => {
                            return (
                                <tr key={product.uid}>
                                    <td className="product-price">{numberWithCommas(product.amount)}</td>
                                    {/*<td className="product-count">{numberWithCommas(product.per_discount)}</td>*/}
                                    <td className="product-count">{product.quantity}</td>
                                    <td className="product-name">{product.name}</td>
                                    <td className="product-name">
                                        {product.product?<img src={product.product && product.product.image ? product.product.image : "/other/skeleton/product.jpg"} alt=""/>:null}
                                    </td>
                                </tr>
                            )
                        })
                        }
                        </tbody>
                    </table>

                    <div className="factor-table-total-row customer_discount-row">
                        <div className="factor-table-total--price customer_discount-val">
                            <span>ریال</span>
                            {<span>{numberWithCommas(factor.discount_amount)}</span>}
                        </div>
                        <span className="customer_discount"> : تخفیف  </span>
                    </div>

                    <div className="factor-table-total-row">
                        <div className="factor-table-total--price">
                            <span>ریال</span>
                            {factor.payable_amount ? <span>{numberWithCommas(factor.payable_amount)}</span> : null}
                        </div>
                        <span> : جمع کل  </span>
                    </div>
                </div>
            </Rodal>




            {selectedReport === "cat" ? <div className="cat-list">
                {invo.length < 1 ?
                    <>
                        <InvCard_skeleton show={load}/>
                    </>
                    : null}
                {invo.map(item => {
                    return (
                        <InvCard item={item} getFactorDetail={getFactorDetail}/>
                    )
                })}
            </div> : null}

            <Nav/>
        </div>
    );

}

export {Report};
